import { compose, withStateHandlers, withProps } from 'recompose';
import { reduce, keyBy, keys } from 'lodash';
import shortid from 'shortid';

/* eslint-disable no-shadow, no-param-reassign, no-unused-vars */

export default ({
  limit,
  offset,
  selected,
  url: defaultUrl,
  deleteUrl = '',
  ordering,
  data,
  search,
  singular: defaultSingular,
  plural: defaultPlural,
} = {}) =>
  compose(
    withProps(props => ({
      plural: props.plural || defaultPlural,
      singular: props.singular || defaultSingular,
      url: props.url || defaultUrl,
    })),
    withStateHandlers(
      props => ({
        data: data || props.data || { count: 0, results: [] },
        offset: offset || props.offset || 0,
        limit: limit || props.limit || 50,
        numSelected: 0,
        search: search || props.search || null,
        selected: selected || props.selected || '',
        ordering: ordering || props.ordering || '',
        isDeleteModalOpen: false,
        refreshToken: null,
      }),
      {
        setData: ({ selected, offset }) => data => {
          const results = keyBy(data.results, 'id');

          selected = reduce(
            selected,
            (acc, value, key) => {
              if (results[key]) acc[key] = true;
              return acc;
            },
            {}
          );

          return { data, selected, offset };
        },
        updateResults: ({ data }) => results => ({
          data: {
            ...data,
            results,
          },
        }),
        setOffset: () => offset => ({ offset }),
        setSelected: () => selected => ({
          selected,
          numSelected: keys(selected).length,
        }),
        setOrdering: () => ordering => ({ ordering }),
        setLimit: () => limit => ({ limit }),
        setSearch: () => search => ({ search }),
        toggleDeleteModal: ({ isDeleteModalOpen }) => () => ({
          isDeleteModalOpen: !isDeleteModalOpen,
        }),
        onDeleted: ({ ordering }) => failed => ({ refreshToken: shortid() }),
        refreshData: () => () => ({ refreshToken: shortid() }),
        onDeleteItem: () => id => ({
          isDeleteModalOpen: true,
          selected: { [id]: true },
        }),
      }
    )
  );



// WEBPACK FOOTER //
// ./src/components/common/Tables/withTable.js